import _ from 'lodash';

export const areEqual = (prevProps: any, nextProps: any): boolean => {
  return _.isEqual(prevProps, nextProps);
};
